import MDEditor from "@uiw/react-md-editor";
import { deleteDoc } from "firebase/firestore";
import { listAll, deleteObject } from "firebase/storage";
import { Link } from "react-router-dom";
import { useRequireAuth } from "../../hooks/useRequireAuth";
import { useVenueName } from "../../hooks/useVenueName";
import {
  collection,
  getDocs,
  doc,
  setDoc,
  getDoc,
} from "firebase/firestore";
import {
  ref,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import { useEffect, useState, useCallback } from "react";
import SectionsRenderer from "../../pages/templates/SectionsRenderer";
import { db, storage } from "../../firebase";
/* ---------- IMAGE COMPRESSION ---------- */
const compressImage = (file, quality = 0.5, scale = 1) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width * scale;
      canvas.height = img.height * scale;
      canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(
        (blob) => {
          URL.revokeObjectURL(url);
          if (!blob) return reject();
          resolve(new File([blob], file.name, { type: "image/jpeg" }));
        },
        "image/jpeg",
        quality
      );
    };
    img.onerror = reject;
    img.src = url;
  });

const slugify = (text) =>
  text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export default function Admin() {
  
  useRequireAuth();
  const { name } = useVenueName();
  
  const [pages, setPages] = useState([]);
  const [selectedPageId, setSelectedPageId] = useState("home");
  const [title, setTitle] = useState("");
  const [sections, setSections] = useState([]);
  const [newTitle, setNewTitle] = useState("");
  const [status, setStatus] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [showAdminModal, setShowAdminModal] = useState(false);
    useEffect(() => {
    const admin = localStorage.getItem("adminNoticeAcceptedAdmin") ;
    if (!admin) {
      setShowAdminModal(true);
    }
  }, []);
  const handleAdminAccept = (open = true) => {
  localStorage.setItem("adminNoticeAcceptedAdmin", "true");
  setShowAdminModal(false);

  if (name && open) {
    window.open(`/${name}/admin/tutorial`, "_blank");
  }
};
const [sekcjaKontakt, setSekcjaKontakt] = useState({
  naglowek: "",
  tekst: "",
  przyciskTekst: "",
  przyciskLink: "",
  obraz: "",
});

const [sekcjaGaleria, setSekcjaGaleria] = useState({
  naglowek: "",
  tekst: "",
  przyciskTekst: "",
  przyciskLink: "",
  obraz: "",
});
  const [sekcjaPowitalna, setSekcjaPowitalna] = useState({
    enabled: true,
    naglowek: "",
    tekst: "",
    przyciskTekst: "",
    przyciskLink: "",
    obraz: "",
  });

  /* ---------- FETCH ---------- */
useEffect(() => {
  if (!name) return;

  const init = async () => {
    // HOME
    const homeRef = doc(db, "venues", name, "pages", "home");
    const homeSnap = await getDoc(homeRef);
    if (!homeSnap.exists()) {
      await setDoc(homeRef, {
        title: "Strona główna",
        sections: [],
        sekcjaPowitalna: {
          naglowek: "Witamy w naszej restauracji",
          tekst: "Najlepsze smaki w mieście",
          przyciskTekst: "Zarezerwuj stolik",
          przyciskLink: "/rezerwacja",
          obraz: "",
        },
        system: true,
        order: 0,
      });
    }

    // FETCH
    const pagesSnap = await getDocs(collection(db, "venues", name, "pages"));
    const data = pagesSnap.docs
      .map((d) => ({ id: d.id, ...d.data() }))
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    
    setPages(data);
    setSelectedPageId(prev => {
  if (data.some(p => p.id === prev)) return prev;
  return data[0]?.id || "home";
});
  };

  init();
}, [name]);


  useEffect(() => {
    if (!name || !selectedPageId) return;
    const fetchPage = async () => {
      const refPage = doc(db, "venues", name, "pages", selectedPageId);
      const snap = await getDoc(refPage);
      if (!snap.exists()) {
        setTitle("");
        setSections([]);
        return;
      }

      if (snap.exists()) {
        const data = snap.data();
setTitle(data.title || "");
setSections(
  (data.sections || [])
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((sec) => {
      if (sec.type === "gallery" && sec.images && Array.isArray(sec.images)) {
        // Jeśli są stare stringi URL → konwertuj na obiekty
        if (sec.images.length > 0 && typeof sec.images[0] === "string") {
          return {
            ...sec,
            images: sec.images.map((url, idx) => ({ url, order: idx })),
          };
        }
      }
      return sec;
    })
);

if (selectedPageId === "home") {
  setSekcjaPowitalna(
    data.sekcjaPowitalna || {
      naglowek: "",
      tekst: "",
      przyciskTekst: "",
      przyciskLink: "",
      obraz: "",
    }
  );
} else if (selectedPageId === "kontakt") {
  setSekcjaKontakt(
    data.sekcjaPowitalna || {
      naglowek: "",
      tekst: "",
      przyciskTekst: "",
      przyciskLink: "",
      obraz: "",
    }
  );
} else if (selectedPageId === "galeria") {
  setSekcjaGaleria(
    data.sekcjaPowitalna || {
      naglowek: "",
      tekst: "",
      przyciskTekst: "",
      przyciskLink: "",
      obraz: "",
    }
  );
}
      }
    };
    fetchPage();
  }, [name, selectedPageId]);
const uploadHeroImage = async (file, pageId) => {
  if (!file) return;

  try {
    const compressed = await compressImage(file, 0.6, 1); // pełna skala, ale kompresja
    const imageRef = ref(
      storage,
      `venues/${name}/${pageId}/hero.jpg` // stała nazwa – nadpisze stare
    );
    await uploadBytes(imageRef, compressed);
    const url = await getDownloadURL(imageRef);

    if (pageId === "home") {
      setSekcjaPowitalna(prev => ({ ...prev, obraz: url }));
    } else if (pageId === "kontakt") {
      setSekcjaKontakt(prev => ({ ...prev, obraz: url }));
    } else if (pageId === "galeria") {
      setSekcjaGaleria(prev => ({ ...prev, obraz: url }));
    }

    setStatus({ type: "success", message: "Obraz tła zapisany" });
    setTimeout(() => setStatus(null), 3000);
  } catch (err) {
    setStatus({ type: "error", message: "Błąd uploadu obrazu tła" });
    setTimeout(() => setStatus(null), 3000);
  }
};
  /* ---------- UNIFIED SAVE ---------- */
const savePage = async () => {
  try {
    const pageRef = doc(db, "venues", name, "pages", selectedPageId);

    const updateData = {
      title,
      sections,
    };

    // ⭐ jedyna specjalna strona
    if (selectedPageId === "home") {
      updateData.sekcjaPowitalna = sekcjaPowitalna;
    }else {
      updateData.sekcjaPowitalna = null;
    }

    await setDoc(pageRef, updateData, { merge: true });

    setStatus({ type: "success", message: "Zapisano pomyślnie" });
    setTimeout(() => setStatus(null), 3000);
  } catch (err) {
    console.error(err);
    setStatus({ type: "error", message: "Błąd zapisu" });
    setTimeout(() => setStatus(null), 3000);
  }
};

const addGallerySection = () => {
  setSections(prev => [
    ...prev,
    {
      id: crypto.randomUUID(),
      type: "gallery",
      title: "Galeria",
      images: [],
      order: prev.length
    }
  ]);
};

  /* ---------- ACTIONS ---------- */
const addPage = async () => {
  if (!newTitle) return;

  const slug = slugify(newTitle);
  if (!slug || slug === "home") {
    setStatus({ type: "error", message: "Nieprawidłowa nazwa strony" });
    setTimeout(() => setStatus(null), 2000);
    return;
  }

  const pageRef = doc(db, "venues", name, "pages", slug);
  const existing = await getDoc(pageRef);
  if (existing.exists()) {
    setStatus({ type: "error", message: "Strona już istnieje" });
    setTimeout(() => setStatus(null), 2000);
    return;
  }

  const pagesSnap = await getDocs(collection(db, "venues", name, "pages"));

  await setDoc(pageRef, {
    title: newTitle,
    sections: [],
    order: pagesSnap.size,
  });

  // ⬇️⬇️⬇️ TO JEST NR 2 ⬇️⬇️⬇️
  setPages(prev => [
    ...prev,
    {
      id: slug,
      title: newTitle,
      sections: [],
      order: prev.length,
    },
  ]);

  setNewTitle("");
  setSelectedPageId(slug);
};


  const addSection = () => {
    setSections((prev) => [
      ...prev,
      {
        id: crypto.randomUUID(),
        type: "text",
        order: prev.length,
        text: "",
        image: "",
        title: "",
        imagePosition: "left",
        uploading: false,
      },
    ]);
  };

  const updateSection = (i, field, value) => {
    setSections((prev) =>
      prev.map((s, idx) => (idx === i ? { ...s, [field]: value } : s))
    );
  };
  const updateSectionById = useCallback((id, patch) => {
  setSections((prev) =>
    prev.map((s) => (s.id === id ? { ...s, ...patch } : s))
  );
}, []);

  const removeSection = (i) => {
    setSections((prev) =>
      prev
        .filter((_, idx) => idx !== i)
        .map((sec, idx) => ({
          ...sec,
          order: idx,
        }))
    );
  };


const uploadImage = async (file, sectionIndex, tileIndex = null) => {
  if (!file) return;

  setSections((prev) =>
    prev.map((s, i) => {
      if (i !== sectionIndex) return s;

      if (tileIndex === null) {
        return { ...s, uploading: true };
      }

      if (!Array.isArray(s.items)) return s;

      const items = [...s.items];
      items[tileIndex] = { ...items[tileIndex], uploading: true };
      return { ...s, items };
    })
  );

  try {
    const compressed = await compressImage(file, 0.6);
    const imageRef = ref(
      storage,
      `venues/${name}/${selectedPageId}/${Date.now()}.jpg`
    );
    await uploadBytes(imageRef, compressed);
    const url = await getDownloadURL(imageRef);

    setSections((prev) =>
      prev.map((s, i) => {
        if (i !== sectionIndex) return s;

        if (tileIndex === null) {
          return { ...s, image: url, uploading: false };
        }

        if (!Array.isArray(s.items)) return s;

        const items = [...s.items];
        items[tileIndex] = { ...items[tileIndex], image: url, uploading: false };
        return { ...s, items };
      })
    );
  } catch {
    setStatus({ type: "error", message: "Błąd uploadu obrazu" });
  }
};

// Dodaj stan – jeśli nie ma, ale już jest sections

// Dodaj funkcję moveSection (analogiczna do moveTile)
const moveSection = (sectionIndex, direction) => {
  setSections((prev) => {
    const newSections = [...prev];
    const newIndex = sectionIndex + direction;
    if (newIndex < 0 || newIndex >= newSections.length) return prev;

    // Zamiana miejsc
    [newSections[sectionIndex], newSections[newIndex]] = [newSections[newIndex], newSections[sectionIndex]];

    // Aktualizacja order dla wszystkich sekcji
    newSections.forEach((sec, idx) => {
      sec.order = idx;
    });

    return newSections;
  });
};
  const addTilesSection = () => {
    setSections((prev) => [
      ...prev,
      {
        id: crypto.randomUUID(),
        type: "tiles",
        title: "Sekcja kafelków",
        order: prev.length,
        items: [
          {
            title: "",
            text: "",
            image: "",
            uploading: false,
            order: 0,
            cta: { text: "", link: "" },
          },
        ],
      },
    ]);
  };

  const addTile = (sectionIndex) => {
    setSections((prev) =>
      prev.map((sec, i) =>
        i === sectionIndex
          ? {
              ...sec,
              items: [
                ...sec.items,
                {
                  title: "",
                  text: "",
                  image: "",
                  uploading: false,
                  order: sec.items.length,
                  cta: { text: "", link: "" },
                },
              ],
            }
          : sec
      )
    );
  };

  const moveTile = (sectionIndex, tileIndex, direction) => {
    setSections((prev) => {
      const newSections = [...prev];
      const items = [...newSections[sectionIndex].items];
      const newIndex = tileIndex + direction;
      if (newIndex < 0 || newIndex >= items.length) return prev;

      // Zamiana miejsc
      [items[tileIndex], items[newIndex]] = [items[newIndex], items[tileIndex]];
      // Aktualizacja order
      items.forEach((item, idx) => (item.order = idx));

      newSections[sectionIndex].items = items;
      return newSections;
    });
  };
// Upload wielu zdjęć naraz do galerii (tylko na stronie galeria, ale możesz użyć gdzie indziej)
const uploadGalleryImages = async (files, sectionIndex) => {
  if (!files?.length) return;

  setSections((prev) =>
    prev.map((s, i) => (i === sectionIndex ? { ...s, uploading: true } : s))
  );

  const uploaded = [];

  for (const file of files) {
    const compressed = await compressImage(file, 0.7, 0.9);
    const refImg = ref(
      storage,
      `venues/${name}/${selectedPageId}/gallery/${Date.now()}_${Math.random()}.jpg`
    );
    await uploadBytes(refImg, compressed);
    const url = await getDownloadURL(refImg);
    uploaded.push({ url });
  }

  setSections((prev) =>
    prev.map((s, i) =>
      i === sectionIndex
        ? {
            ...s,
            images: [
              ...(s.images || []),
              ...uploaded.map((img, idx) => ({
                ...img,
                order: (s.images?.length || 0) + idx,
              })),
            ],
            uploading: false,
          }
        : s
    )
  );
};

// Usuń zdjęcie z galerii
const removeGalleryImage = (sectionIndex, imageIndex) => {
  setSections((prev) =>
    prev.map((s, i) =>
      i === sectionIndex
        ? {
            ...s,
            images: s.images
              .filter((_, idx) => idx !== imageIndex)
              .map((img, idx) => ({ ...img, order: idx })), // przelicz order
          }
        : s
    )
  );
};

// Przesuń zdjęcie w galerii w górę/w dół
const moveGalleryImage = (sectionIndex, imageIndex, direction) => {
  setSections((prev) => {
    const newSections = [...prev];
    const currentImages = newSections[sectionIndex].images || [];
    const imagesCopy = [...currentImages];

    const newIndex = imageIndex + direction;
    if (newIndex < 0 || newIndex >= imagesCopy.length) return prev;

    // Zamiana miejsc
    [imagesCopy[imageIndex], imagesCopy[newIndex]] = [imagesCopy[newIndex], imagesCopy[imageIndex]];

    // Tworzymy zupełnie nowe obiekty z nowym order
    const updatedImages = imagesCopy.map((img, idx) => ({
      ...img,         // kopiujemy wszystkie pola (url, itp.)
      order: idx      // nadpisujemy order
    }));

    newSections[sectionIndex] = {
      ...newSections[sectionIndex],
      images: updatedImages
    };

    return newSections;
  });
};
  const removeTile = (sectionIndex, tileIndex) => {
    setSections((prev) =>
      prev.map((sec, i) =>
        i === sectionIndex
          ? {
              ...sec,
              items: sec.items
                .filter((_, idx) => idx !== tileIndex)
                .map((item, idx) => ({ ...item, order: idx })),
            }
          : sec
      )
    );
  };

  const deletePageImages = async (pageId) => {
    const folderRef = ref(storage, `venues/${name}/${pageId}`);
    try {
      const result = await listAll(folderRef);
      await Promise.all(result.items.map((item) => deleteObject(item)));
    } catch (err) {
      console.warn("Nie udało się usunąć obrazków:", err);
    }
  };

  const confirmDeletePage = async () => {
    if (["home", ].includes(selectedPageId)) {
  setStatus({ type: "error", message: "Nie można usunąć systemowej strony" });
  setTimeout(() => setStatus(null), 3000);
  return;
}
    try {
      await deletePageImages(selectedPageId);
      await deleteDoc(doc(db, "venues", name, "pages", selectedPageId));
      const remaining = pages.filter((p) => p.id !== selectedPageId);
      setPages(remaining);
      setSelectedPageId(remaining[0]?.id || "home");
      setShowDeleteModal(false);
      setStatus({ type: "success", message: "Strona usunięta" });
      setTimeout(() => setStatus(null), 3000);
    } catch {
      setStatus({ type: "error", message: "Błąd usuwania" });
      setTimeout(() => setStatus(null), 3000);
    }
  };


  const addCtaSection = () => {
    setSections((prev) => [
      ...prev,
      {
        id: crypto.randomUUID(),
        type: "cta",
        order: prev.length,
        title: "Zarezerwuj stolik już dziś!",
        text: "Nie czekaj – najlepsze miejsca szybko się rozchodzą. Zarezerwuj online w kilka sekund.",
        cta: { text: "Zarezerwuj teraz", link: "/rezerwacja" },
      },
    ]);
  };
  const addContactSection = () => {
  setSections(prev => {
    if (prev.some(sec => sec.type === "contact")) {
      setStatus({
        type: "error",
        message: "Sekcja kontaktowa może być tylko jedna"
      });
      return prev;
    }

    return [
      ...prev,
      {
        id: crypto.randomUUID(),
        type: "contact",
        order: prev.length,
        title: "Kontakt",
        address: "",
        phone: "",
        email: "",
        nip: "",
        instagram: "",
        mapIframe: ""
      }
    ];
  });
};

  /* ---------- UI ---------- */
  return (
<div className="min-h-screen bg-gray-100 pt-16 pb-24 md:pt-20 flex justify-center items-center">
    {/* Górne narzędzia */}
  <div className="max-w-7xl">
    <div className="mx-4 sm:mx-6 mb-6 bg-white px-4 sm:px-6 py-4 shadow rounded-lg max-w-5xl">
      <p className="text-gray-700 text-lg sm:text-xl mb-3 font-semibold">Inne narzędzia</p>
      <div className="flex flex-wrap gap-3 sm:gap-4">
        <Link
          to={`/${name}/admin/edytor/nawigacja`}
          className="bg-emerald-600 text-white px-4 sm:px-5 py-2.5 sm:py-3 rounded-lg hover:bg-emerald-700 transition text-sm sm:text-base font-medium"
        >
          Edytor nawigacji
        </Link>
        <Link
          to={`/${name}/admin/edytor/kolor`}
          className="bg-emerald-600 text-white px-4 sm:px-5 py-2.5 sm:py-3 rounded-lg hover:bg-emerald-700 transition text-sm sm:text-base font-medium"
        >
          Edytor koloru
        </Link>
        <Link
          to={`/${name}/admin/zmien-haslo`}
          className="bg-emerald-600 text-white px-4 sm:px-5 py-2.5 sm:py-3 rounded-lg hover:bg-emerald-700 transition text-sm sm:text-base font-medium"
        >
          Resetuj hasło
        </Link>
      </div>
    </div>

    {/* Wybór i dodawanie strony */}
    <div className="mx-4 sm:mx-6 mb-8 bg-white px-4 sm:px-6 py-5 shadow rounded-lg">
      <div className="font-bold text-lg sm:text-xl mb-4">Panel edycji – {name}</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Wybierz stronę</label>
          <select
            value={selectedPageId}
            onChange={(e) => setSelectedPageId(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition"
          >
            {pages.map((p) => (
              <option key={p.id} value={p.id}>
                {p.title}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Dodaj nową stronę</label>
          <input
            placeholder="Tytuł strony"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-4 py-3 mb-3 focus:ring-2 focus:ring-emerald-500 transition"
          />
          <button
            onClick={addPage}
            className="w-full bg-emerald-600 text-white px-6 py-3 rounded-lg hover:bg-emerald-700 transition font-medium"
          >
            Dodaj stronę
          </button>
        </div>
      </div>
    </div>

    {/* Główny edytor */}
    <div className="mx-4 sm:mx-6 bg-white rounded-xl shadow-lg p-4 sm:p-6 lg:p-8">
      {/* Nazwa strony */}
      <div className="mb-8">
        <label className="block text-sm font-medium text-gray-700 mb-2">Nazwa strony</label>
        <input
          value={title}
          disabled
          className="w-full border border-gray-300 rounded-lg px-5 py-4 text-2xl sm:text-3xl font-bold bg-gray-100 cursor-not-allowed"
        />
      </div>

      {/* Sekcja powitalna (home / kontakt / galeria) */}
      {(selectedPageId === "home" || selectedPageId === "kontakt" || selectedPageId === "galeria") && (
        <div className="mb-12 border-2 border-emerald-500 rounded-xl p-5 sm:p-8 bg-emerald-50">
          <label className="flex items-center gap-3 mb-6 font-semibold">
          <input
            type="checkbox"
            checked={
              selectedPageId === "home"
                ? sekcjaPowitalna.enabled
                : selectedPageId === "kontakt"
                ? sekcjaKontakt.enabled
                : sekcjaGaleria.enabled
            }
            onChange={(e) => {
              const val = e.target.checked;
              if (selectedPageId === "home") setSekcjaPowitalna(p => ({ ...p, enabled: val }));
              else if (selectedPageId === "kontakt") setSekcjaKontakt(p => ({ ...p, enabled: val }));
              else setSekcjaGaleria(p => ({ ...p, enabled: val }));
            }}
          />
          Włącz sekcję powitalną
        </label>

          <h2 className="text-xl sm:text-2xl font-bold mb-6">
            Sekcja powitalna – {selectedPageId === "home" ? "Strona główna" : selectedPageId === "kontakt" ? "Kontakt" : "Galeria"}
          </h2>

          <input
            placeholder="Nagłówek"
            value={
              selectedPageId === "home" ? sekcjaPowitalna.naglowek :
              selectedPageId === "kontakt" ? sekcjaKontakt.naglowek :
              sekcjaGaleria.naglowek
            }
            onChange={(e) => {
              const val = e.target.value;
              if (selectedPageId === "home") setSekcjaPowitalna(p => ({ ...p, naglowek: val }));
              else if (selectedPageId === "kontakt") setSekcjaKontakt(p => ({ ...p, naglowek: val }));
              else setSekcjaGaleria(p => ({ ...p, naglowek: val }));
            }}
            className="w-full mb-5 border rounded-lg px-5 py-3 text-xl sm:text-2xl font-semibold focus:ring-2 focus:ring-emerald-500 transition"
          />

          <div data-color-mode="light" className="mb-6">
           
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
            <input
              placeholder="Tekst przycisku"
              value={
                selectedPageId === "home" ? sekcjaPowitalna.przyciskTekst :
                selectedPageId === "kontakt" ? sekcjaKontakt.przyciskTekst :
                sekcjaGaleria.przyciskTekst
              }
              onChange={(e) => {
                const val = e.target.value;
                if (selectedPageId === "home") setSekcjaPowitalna(p => ({ ...p, przyciskTekst: val }));
                else if (selectedPageId === "kontakt") setSekcjaKontakt(p => ({ ...p, przyciskTekst: val }));
                else setSekcjaGaleria(p => ({ ...p, przyciskTekst: val }));
              }}
              className="border rounded-lg px-5 py-3 focus:ring-2 focus:ring-emerald-500 transition"
            />
            <input
              placeholder="Link przycisku"
              value={
                selectedPageId === "home" ? sekcjaPowitalna.przyciskLink :
                selectedPageId === "kontakt" ? sekcjaKontakt.przyciskLink :
                sekcjaGaleria.przyciskLink
              }
              onChange={(e) => {
                const val = e.target.value;
                if (selectedPageId === "home") setSekcjaPowitalna(p => ({ ...p, przyciskLink: val }));
                else if (selectedPageId === "kontakt") setSekcjaKontakt(p => ({ ...p, przyciskLink: val }));
                else setSekcjaGaleria(p => ({ ...p, przyciskLink: val }));
              }}
              className="border rounded-lg px-5 py-3 focus:ring-2 focus:ring-emerald-500 transition"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Obraz tła sekcji powitalnej</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => uploadHeroImage(e.target.files?.[0], selectedPageId)}
              className="text-sm block w-full file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:bg-emerald-600 file:text-white hover:file:bg-emerald-700"
            />
            {(selectedPageId === "home" ? sekcjaPowitalna.obraz :
              selectedPageId === "kontakt" ? sekcjaKontakt.obraz :
              sekcjaGaleria.obraz) && (
              <img
                src={
                  selectedPageId === "home" ? sekcjaPowitalna.obraz :
                  selectedPageId === "kontakt" ? sekcjaKontakt.obraz :
                  sekcjaGaleria.obraz
                }
                alt="Tło sekcji powitalnej"
                className="mt-4 w-full max-h-80 sm:max-h-96 object-cover rounded-lg shadow-lg"
              />
            )}
          </div>
        </div>
      )}

      {/* Sekcje treści */}
      <div className="space-y-10">
        {sections.map((s, sectionIndex) => (
          <div
            key={s.id}
            className="border border-gray-200 rounded-xl p-5 sm:p-8 bg-gray-50 relative shadow-sm"
          >
            {/* Sterowanie sekcją */}
            <div className="absolute top-4 right-4 flex items-center gap-2 z-20">
              <button
                onClick={() => moveSection(sectionIndex, -1)}
                disabled={sectionIndex === 0}
                className="bg-gray-200 hover:bg-gray-300 disabled:opacity-40 p-2 rounded-lg transition text-sm"
                title="W górę"
              >
                ↑
              </button>
              <button
                onClick={() => moveSection(sectionIndex, 1)}
                disabled={sectionIndex === sections.length - 1}
                className="bg-gray-200 hover:bg-gray-300 disabled:opacity-40 p-2 rounded-lg transition text-sm"
                title="W dół"
              >
                ↓
              </button>
              <button
                onClick={() => removeSection(sectionIndex)}
                className="ml-4 text-red-600 hover:text-red-800 font-medium text-sm"
              >
                Usuń sekcję
              </button>
            </div>

            {/* Typy sekcji */}
            {s.type === "tiles" ? (
              <div className="space-y-6">
                <h3 className="text-lg sm:text-xl font-semibold mt-10">Sekcja kafelków</h3>
                <input
                  type="text"
                  placeholder="Tytuł sekcji (nad kafelkami)"
                  value={s.title || ""}
                  onChange={(e) => updateSectionById(s.id, { title: e.target.value })}
                  className="w-full border rounded-lg px-5 py-3 text-lg sm:text-xl font-medium focus:ring-2 focus:ring-emerald-500 transition"
                />

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {s.items.map((item, tileIndex) => (
                    <div
                      key={tileIndex}
                      className="border border-gray-300 rounded-xl p-4 sm:p-6 bg-white relative shadow-md"
                    >
                      {/* Strzałki kafelka */}
                      <div className="absolute top-3 right-3 flex gap-1.5 z-10">
                        <button
                          onClick={() => moveTile(sectionIndex, tileIndex, -1)}
                          disabled={tileIndex === 0}
                          className="bg-gray-200 hover:bg-gray-300 disabled:opacity-40 p-1.5 rounded text-xs transition"
                        >
                          ↑
                        </button>
                        <button
                          onClick={() => moveTile(sectionIndex, tileIndex, 1)}
                          disabled={tileIndex === s.items.length - 1}
                          className="bg-gray-200 hover:bg-gray-300 disabled:opacity-40 p-1.5 rounded text-xs transition"
                        >
                          ↓
                        </button>
                      </div>

                      <input
                        placeholder="Tytuł kafelka"
                        value={item.title || ""}
                        onChange={(e) =>
                          setSections((prev) =>
                            prev.map((sec, si) =>
                              si === sectionIndex
                                ? {
                                    ...sec,
                                    items: sec.items.map((it, ti) =>
                                      ti === tileIndex ? { ...it, title: e.target.value } : it
                                    ),
                                  }
                                : sec
                            )
                          )
                        }
                        className="w-full mb-4 border rounded-lg px-4 py-3 font-medium text-base sm:text-lg focus:ring-2 focus:ring-emerald-500 transition mt-10"
                      />

                      <div data-color-mode="light" className="mb-4">
                        <MDEditor
                        key={`${selectedPageId}-${s.id}-${tileIndex}`}
                          value={item.text || ""}
                          onChange={(v) =>
                            setSections((prev) =>
                              prev.map((sec, si) =>
                                si === sectionIndex
                                  ? {
                                      ...sec,
                                      items: sec.items.map((it, ti) =>
                                        ti === tileIndex ? { ...it, text: v || "" } : it
                                      ),
                                    }
                                  : sec
                              )
                            )
                          }
                          height={400}
                          preview="edit"
                        />
                      </div>

                      <div className="mt-4">
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => uploadImage(e.target.files?.[0], sectionIndex, tileIndex)}
                          className="text-sm block w-full file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:bg-emerald-600 file:text-white hover:file:bg-emerald-700"
                        />
                        {item.uploading && <p className="text-sm text-gray-500 mt-2">Przetwarzanie...</p>}
                        {item.image && (
                          <img
                            src={item.image}
                            alt="Podgląd kafelka"
                            className="mt-4 w-full max-h-48 object-cover rounded-lg shadow"
                          />
                        )}
                      </div>

                      <div className="mt-5 space-y-3">
                        <p className="font-semibold text-sm">Przycisk</p>
                        <input
                          placeholder="Tekst przycisku"
                          value={item.cta?.text || ""}
                          onChange={(e) =>
                            setSections((prev) =>
                              prev.map((sec, si) =>
                                si === sectionIndex
                                  ? {
                                      ...sec,
                                      items: sec.items.map((it, ti) =>
                                        ti === tileIndex
                                          ? { ...it, cta: { ...it.cta, text: e.target.value } }
                                          : it
                                      ),
                                    }
                                  : sec
                              )
                            )
                          }
                          className="w-full border rounded-lg px-4 py-2 text-sm focus:ring-2 focus:ring-emerald-500 transition"
                        />
                        <input
                          placeholder="Link przycisku"
                          value={item.cta?.link || ""}
                          onChange={(e) =>
                            setSections((prev) =>
                              prev.map((sec, si) =>
                                si === sectionIndex
                                  ? {
                                      ...sec,
                                      items: sec.items.map((it, ti) =>
                                        ti === tileIndex
                                          ? { ...it, cta: { ...it.cta, link: e.target.value } }
                                          : it
                                      ),
                                    }
                                  : sec
                              )
                            )
                          }
                          className="w-full border rounded-lg px-4 py-2 text-sm focus:ring-2 focus:ring-emerald-500 transition"
                        />
                        {item.cta?.text && (
                          <button
                            onClick={() =>
                              setSections((prev) =>
                                prev.map((sec, si) =>
                                  si === sectionIndex
                                    ? {
                                        ...sec,
                                        items: sec.items.map((it, ti) =>
                                          ti === tileIndex ? (({ cta, ...rest }) => rest)(it) : it
                                        ),
                                      }
                                    : sec
                                )
                              )
                            }
                            className="text-xs text-red-600 hover:underline"
                          >
                            Usuń przycisk
                          </button>
                        )}
                      </div>

                      <button
                        onClick={() => removeTile(sectionIndex, tileIndex)}
                        className="mt-5 text-red-600 text-sm hover:underline"
                      >
                        Usuń kafelek
                      </button>
                    </div>
                  ))}
                </div>

                <button
                  onClick={() => addTile(sectionIndex)}
                  className="w-full sm:w-auto bg-emerald-600 text-white px-6 py-3 rounded-lg hover:bg-emerald-700 transition font-medium"
                >
                  + Dodaj kafelek
                </button>
              </div>
            ) : s.type === "contact" ? (
              <div className="space-y-6 border-2 border-blue-400 rounded-xl p-6 sm:p-8 bg-blue-50 mt-8">
                <h3 className="text-xl sm:text-2xl font-bold text-blue-800 mt-10">Sekcja kontaktowa</h3>
                <input
                  type="text"
                  placeholder="Tytuł sekcji (np. Kontakt)"
                  value={s.title || ""}
                  onChange={(e) => updateSection(sectionIndex, "title", e.target.value)}
                  className="w-full border rounded-lg px-5 py-3 text-lg sm:text-xl font-semibold focus:ring-2 focus:ring-blue-500 transition"
                />
                <label className="block text-sm font-medium mb-2">Adres</label>
                <input
                  value={s.address || ""}
                  onChange={(e) => updateSection(sectionIndex, "address", e.target.value)}
                  className="w-full border rounded-lg px-5 py-3 focus:ring-2 focus:ring-blue-500 transition"
                />
                <label className="block text-sm font-medium mb-2 mt-4">Telefon</label>
                <input
                  value={s.phone || ""}
                  onChange={(e) => updateSection(sectionIndex, "phone", e.target.value)}
                  className="w-full border rounded-lg px-5 py-3 focus:ring-2 focus:ring-blue-500 transition"
                />
                <label className="block text-sm font-medium mb-2 mt-4">NIP</label>
                <input
                  value={s.nip || ""}
                  onChange={(e) => updateSection(sectionIndex, "nip", e.target.value)}
                  className="w-full border rounded-lg px-5 py-3 focus:ring-2 focus:ring-blue-500 transition"
                />
                <label className="block text-sm font-medium mb-2 mt-4">Email</label>
                <input
                  value={s.email || ""}
                  onChange={(e) => updateSection(sectionIndex, "email", e.target.value)}
                  className="w-full border rounded-lg px-5 py-3 focus:ring-2 focus:ring-blue-500 transition"
                />
                <label className="block text-sm font-medium mb-2 mt-4">Instagram</label>
                <input
                  value={s.instagram || ""}
                  onChange={(e) => updateSection(sectionIndex, "instagram", e.target.value)}
                  placeholder="np. https://www.instagram.com/twojprofil"
                  className="w-full border rounded-lg px-5 py-3 focus:ring-2 focus:ring-blue-500 transition"
                />

                <label className="block text-sm font-medium mb-2 mt-4">Iframe mapy Google</label>
                <textarea
                  value={s.mapIframe || ""}
                  onChange={(e) => updateSection(sectionIndex, "mapIframe", e.target.value)}
                  rows={6}
                  className="w-full border rounded-lg px-5 py-3 font-mono text-sm focus:ring-2 focus:ring-blue-500 transition"
                />
              </div>
            ) : s.type === "gallery" ? (
              <div className="space-y-6">
                <input
                  placeholder="Tytuł galerii"
                  value={s.title || ""}
                  onChange={(e) => updateSection(sectionIndex, "title", e.target.value)}
                  className="w-full border rounded-lg px-5 py-3 text-xl sm:text-2xl font-bold focus:ring-2 focus:ring-emerald-500 transition mt-8"
                />
                <div>
                  <label className="block text-sm font-medium mb-2">Dodaj wiele zdjęć naraz</label>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={(e) => uploadGalleryImages(e.target.files, sectionIndex)}
                    className="text-sm block w-full file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:bg-emerald-600 file:text-white hover:file:bg-emerald-700"
                  />
                  {s.uploading && <p className="text-emerald-600 font-medium mt-3">Przetwarzanie i upload zdjęć...</p>}
                </div>

                {s.images && s.images.length > 0 && (
                  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 mt-6">
                    {[...s.images]
                      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
                      .map((img, sortedIndex) => {
                        const originalIndex = s.images.findIndex((i) => i.url === img.url);
                        return (
                          <div key={img.url} className="relative group bg-white rounded-xl shadow-lg overflow-hidden">
                            <div className="absolute top-2 right-2 z-10 flex flex-col gap-2 opacity-0 group-hover:opacity-100 transition">
                              <button
                                onClick={() => moveGalleryImage(sectionIndex, originalIndex, -1)}
                                disabled={sortedIndex === 0}
                                className="bg-white/80 hover:bg-white p-2 rounded text-sm disabled:opacity-30"
                              >
                                ↑
                              </button>
                              <button
                                onClick={() => moveGalleryImage(sectionIndex, originalIndex, 1)}
                                disabled={sortedIndex === s.images.length - 1}
                                className="bg-white/80 hover:bg-white p-2 rounded text-sm disabled:opacity-30"
                              >
                                ↓
                              </button>
                            </div>
                            <button
                              onClick={() => removeGalleryImage(sectionIndex, originalIndex)}
                              className="absolute top-2 left-2 z-10 bg-red-600 text-white w-8 h-8 rounded-full hover:bg-red-700 opacity-0 group-hover:opacity-100 transition flex items-center justify-center text-xl"
                            >
                              ×
                            </button>
                            <img
                              src={img.url}
                              alt={`Galeria ${sortedIndex + 1}`}
                              className="w-full h-64 object-cover"
                            />
                          </div>
                        );
                      })}
                  </div>
                )}

                {(!s.images || s.images.length === 0) && (
                  <p className="text-gray-500 italic text-center py-12">
                    Brak zdjęć w galerii – dodaj pierwsze powyżej
                  </p>
                )}
              </div>
            ) : s.type === "cta" ? (
              <div className="space-y-6 border-2 border-emerald-400 rounded-xl p-6 sm:p-8 bg-emerald-50">
                <h3 className="text-xl sm:text-2xl font-bold text-emerald-800 mt-10">Sekcja z przyciskiem</h3>
                <input
                  type="text"
                  placeholder="Nagłówek"
                  value={s.title || ""}
                  onChange={(e) => updateSection(sectionIndex, "title", e.target.value)}
                  className="w-full border rounded-lg px-5 py-3 text-lg sm:text-xl font-semibold focus:ring-2 focus:ring-emerald-500 transition"
                />
                <div data-color-mode="light">
                  <MDEditor
                  key={`${selectedPageId}-${s.id}`}
                    value={s.text || ""}
                    onChange={(val) => updateSectionById(s.id, { text: val || "" })}
                    height={400}
                    preview="edit"
                  />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-2">Tekst przycisku</label>
                    <input
                      type="text"
                      value={s.cta?.text || ""}
                      onChange={(e) => updateSection(sectionIndex, "cta", { ...s.cta, text: e.target.value })}
                      className="w-full border rounded-lg px-5 py-3 focus:ring-2 focus:ring-emerald-500 transition"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">Link przycisku</label>
                    <input
                      type="text"
                      value={s.cta?.link || ""}
                      onChange={(e) => updateSection(sectionIndex, "cta", { ...s.cta, link: e.target.value })}
                      className="w-full border rounded-lg px-5 py-3 focus:ring-2 focus:ring-emerald-500 transition"
                    />
                  </div>
                </div>
              </div>
            ) : (
              // Sekcja tekstowa (domyślna)
              <div className="space-y-6">
                <input
                  placeholder="Tytuł sekcji"
                  value={s.title || ""}
                  onChange={(e) => updateSection(sectionIndex, "title", e.target.value)}
                  className="w-full border rounded-lg px-5 py-3 text-lg sm:text-xl font-semibold focus:ring-2 focus:ring-emerald-500 transition mt-10"
                />
                <div data-color-mode="light">
                  <MDEditor
                  
                    value={s.text || ""}
                    onChange={(val) => updateSection(sectionIndex, "text", val || "")}
                    height={280}
                    preview="edit"
                  />
                </div>
                <div className="space-y-4">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => uploadImage(e.target.files?.[0], sectionIndex)}
                    className="text-sm block w-full file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:bg-emerald-600 file:text-white hover:file:bg-emerald-700"
                  />
                  {s.uploading && <p className="text-sm text-gray-500">Przetwarzanie...</p>}
                  {s.image && (
                    <>
                      <img
                        src={s.image}
                        alt="Podgląd"
                        className="mt-4 w-full max-h-80 rounded-lg shadow object-cover"
                      />
                      <select
                        value={s.imagePosition || "left"}
                        onChange={(e) => updateSection(sectionIndex, "imagePosition", e.target.value)}
                        className="border rounded-lg px-4 py-2 w-full max-w-xs focus:ring-2 focus:ring-emerald-500 transition"
                      >
                        <option value="left">Zdjęcie po lewej</option>
                        <option value="right">Zdjęcie po prawej</option>
                        <option value="none">Ukryj zdjęcie</option>
                      </select>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Przyciski dodawania nowych sekcji */}
      <div className="flex flex-wrap gap-4 mt-12">
        <button
          onClick={addSection}
          className="flex-1 sm:flex-initial bg-gray-200 hover:bg-gray-300 px-6 py-4 rounded-lg font-medium transition"
        >
          + Sekcja tekstowa
        </button>
        <button
          onClick={addTilesSection}
          className="flex-1 sm:flex-initial bg-gray-200 hover:bg-gray-300 px-6 py-4 rounded-lg font-medium transition"
        >
          + Sekcja kafelków
        </button>
        <button
          onClick={addCtaSection}
          className="flex-1 sm:flex-initial bg-emerald-600 text-white hover:bg-emerald-700 px-6 py-4 rounded-lg font-medium transition"
        >
          + Sekcja z przyciskiem
        </button>
        <button
          onClick={addContactSection}
          className="flex-1 sm:flex-initial bg-blue-600 text-white hover:bg-blue-700 px-6 py-4 rounded-lg font-medium transition"
        >
          + Sekcja kontaktowa
        </button>
        <button
          onClick={addGallerySection}
          className="flex-1 sm:flex-initial bg-purple-600 text-white hover:bg-purple-700 px-6 py-4 rounded-lg font-medium transition"
        >
          + Sekcja galerii
        </button>

      </div>
      {selectedPageId !== "home" && (
        <button
          onClick={() => setShowDeleteModal(true)}
          className="mt-6 w-full border border-red-600 text-red-600 py-4 rounded-lg font-bold hover:bg-red-50 transition"
        >
          Usuń stronę
        </button>
      )}

      {/* Przycisk podglądu */}
{/* ================= MOBILE: PIRAMIDA ================= */}
<div
  className="
    fixed bottom-6 left-1/2 -translate-x-1/2 z-50
    flex flex-col items-center gap-4
    sm:hidden
  "
>
  <button
    onClick={savePage}
    className="bg-emerald-600 text-white px-10 py-5 rounded-xl shadow-2xl font-bold"
  >
    Zapisz
  </button>

  <div className="flex gap-4">
    <button
      onClick={() => setIsPreviewOpen(true)}
      className="bg-blue-600 text-white px-6 py-4 rounded-full shadow-xl font-semibold"
    >
      Podgląd
    </button>

    <Link
      to={`/${name}/admin/tutorial`}
      className="bg-blue-600 text-white px-6 py-4 rounded-full shadow-xl font-semibold text-center"
    >
      Poradnik
    </Link>
  </div>
</div>

{/* ================= DESKTOP: PO BOKACH ================= */}
<button
  onClick={savePage}
  className="
    hidden sm:block
    fixed bottom-6 left-1/2 -translate-x-1/2 z-50
    bg-emerald-600 text-white px-10 py-5 rounded-xl shadow-2xl font-bold
    hover:bg-emerald-700 transition
  "
>
  Zapisz
</button>

<button
  onClick={() => setIsPreviewOpen(true)}
  className="
    hidden sm:flex
    fixed bottom-6 right-6 z-40
    bg-blue-600 text-white px-8 py-5 rounded-full shadow-2xl font-semibold
    hover:bg-blue-700 transition
  "
>
  Podgląd
</button>

<Link
  to={`/${name}/admin/tutorial`}
  className="
    hidden sm:flex
    fixed bottom-6 left-6 z-40
    bg-blue-600 text-white px-8 py-5 rounded-full shadow-2xl font-semibold
    hover:bg-blue-700 transition
  "
>
  Poradnik
</Link>


    </div>

    {/* Toast */}
    {status && (
      <div className="fixed bottom-10 left-1/2 -translate-x-1/2 z-50">
        <div
          className={`px-8 sm:px-10 py-4 sm:py-5 rounded-full shadow-2xl text-white font-bold text-base sm:text-lg ${
            status.type === "success" ? "bg-emerald-600" : "bg-red-600"
          }`}
        >
          {status.message}
        </div>
      </div>
    )}

    {/* Modal podglądu pełnoekranowego */}
    {isPreviewOpen && (
      <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4">
        <div className="relative w-full h-full max-w-7xl max-h-full bg-white rounded-2xl overflow-hidden shadow-2xl">
          <button
            onClick={() => setIsPreviewOpen(false)}
            className="absolute top-4 right-4 z-10 bg-red-600 text-white w-12 h-12 rounded-full hover:bg-red-700 flex items-center justify-center text-3xl shadow-lg"
          >
            ×
          </button>
          <div className="bg-gray-900 text-white px-6 sm:px-10 py-6 sm:py-8">
            <h1 className="text-2xl sm:text-4xl font-bold">{title || "Podgląd strony"}</h1>
          </div>
          <div className="h-full overflow-y-auto bg-gray-50 p-4">
          <SectionsRenderer
            title={title}
            sections={sections}
            sekcjaPowitalna={
              selectedPageId === "home"
                ? sekcjaPowitalna
                : selectedPageId === "kontakt"
                ? sekcjaKontakt
                : selectedPageId === "galeria"
                ? sekcjaGaleria
                : undefined
            }
          />

          </div>
        </div>
      </div>
    )}

    {/* Modal usuwania strony */}
    {showDeleteModal && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
        <div className="bg-white rounded-xl p-6 sm:p-8 max-w-lg w-full shadow-2xl">
          <h3 className="text-xl sm:text-2xl font-bold mb-4 text-red-600">Usunąć stronę?</h3>
          <p className="text-gray-700 mb-6">
            Ta operacja jest <strong>nieodwracalna</strong>. Zostaną usunięte:
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-8 space-y-1">
            <li>treść strony</li>
            <li>wszystkie sekcje</li>
            <li>wszystkie obrazki</li>
          </ul>
          <div className="flex justify-end gap-4">
            <button
              onClick={() => setShowDeleteModal(false)}
              className="px-6 py-3 rounded-lg border border-gray-300 hover:bg-gray-100 transition"
            >
              Anuluj
            </button>
            <button
              onClick={confirmDeletePage}
              className="px-6 py-3 rounded-lg bg-red-600 text-white font-bold hover:bg-red-700 transition"
            >
              Usuń na stałe
            </button>
          </div>
        </div>
      </div>
    )}

    {/* Modal powitalny / tutorial */}
    {showAdminModal && (
      <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl p-6 sm:p-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 text-center">Krótki poradnik</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            Przygotowałem dla Ciebie <strong>prosty poradnik</strong>, który krok po kroku pokazuje, jak zmieniać treści na stronie.
          </p>
          <p className="text-gray-700 leading-relaxed mb-4">
            Wszystko działa na zasadzie: <strong>kliknij → wpisz → zapisz</strong>.
          </p>
          <p className="text-gray-700 leading-relaxed mb-6">
            Tutorial znajdziesz pod adresem:
            <br />
            <code className="bg-gray-100 px-4 py-2 rounded-lg mt-2 inline-block text-sm sm:text-base font-medium break-all">
              {window.location.origin}/{name}/admin/tutorial
            </code>
          </p>
          <div className="space-y-4">
            <button
              onClick={() => handleAdminAccept(true)}
              className="w-full py-4 sm:py-5 rounded-xl font-bold text-white text-lg sm:text-xl transition bg-blue-600 hover:bg-blue-700 shadow-lg"
            >
              Otwórz tutorial i zobacz jak edytować
            </button>
            <button
              onClick={() => handleAdminAccept(false)}
              className="w-full py-3 sm:py-4 rounded-xl font-bold text-blue-700 text-base sm:text-lg transition bg-blue-50 hover:bg-blue-100 border-2 border-blue-300"
            >
              Pomiń – pokaż mi panel
            </button>
          </div>
        </div>
      </div>
    )}
    </div>
  </div>
  );
}
;

